var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-fluid",attrs:{"src":require('../assets/img/avatar.jpg'),"alt":"Full Name"}})}
var staticRenderFns = []

export { render, staticRenderFns }